import React, { useEffect, useState } from 'react';
import { useTheme, ITheme } from 'src/theme';
import { css } from '@linaria/core';
import { useAvivaSelector } from '@redux/hook';
import { SQSPocketResponse } from '@models/SQSPocketRequest.model';
import { GAAviva } from '@utils/gaAviva';
import { Helpers } from '@utils/helpers';

import { LeftGrid, FullGrid, ContainerGrid, Container } from '@components/LayoutGrid';
import ContainerBlock from '@components/ContainerBlock';
import Heading from '@components/Heading';
import Text from '@components/Text';
import Listing from '@components/Listing';
import ContactBox from '@components/ContactBox';
import Divider from '@components/Divider';
import Link from '@components/Link';


const fluidBox = css`
  margin-top: -40px;
`;
const marginTop = css`
  @media screen and (min-width: 768px) {
    margin-top: 30px
  }
`;

export interface ThankYouProps { }

const trackOnload = (): void => {
  const GA = GAAviva.getInstance();
  let { form } = GA.digitalData;
  form.name = "";
  GA.trackPageLoad({ form });
}

function ThankYou(props: ThankYouProps) {

  const contactInformation = useAvivaSelector(state => state.staticData.contactInformation);
  const quoteRawResponse = useAvivaSelector(state => state.dpiStep1.quoteRawResponse);
  const policyNo = useAvivaSelector(state => state.dpiStep5.policyNo);
  const [summaries, setSummaries] = useState<any>(undefined);

  const theme: ITheme = useTheme();
  useEffect(() => {
    const quotation: SQSPocketResponse = new SQSPocketResponse(quoteRawResponse);
    if (summaries === undefined && quoteRawResponse) {
      let planDetails = [...quotation.dpiPlanDetails.filter(o => !o.reviewOnly)]
      const premium = planDetails[planDetails.length - 1];
      planDetails[planDetails.length - 1] = { ...premium, fontWeight: 'bold' }
      const data = [
        { text: 'Policy number', value: policyNo },
        ...planDetails,
        { text: 'Premium payment method', value: 'Credit Card', fontWeight: 'bold' }
      ]
      setSummaries(data);
      trackOnload();
    }
    Helpers.clearCached();
  }, [quoteRawResponse, summaries, setSummaries, policyNo])
  return (
    <Container>
      <ContainerBlock className={fluidBox} background={theme.colors.secondary} padding="40px 0" paddingTablet="130px 0 110px 30px">
        <ContainerGrid>
          <FullGrid>
            <LeftGrid>
              <Heading fontWeight={600} color={theme.colors.white} margin="0 0 10px">Thank you! </Heading>
              <Text fontSize={theme.fontSize.label} fontWeight={300} color={theme.colors.white}>Your application has been successfully submitted. We’ll notify you on the status of your application within 5 working days.</Text>
            </LeftGrid>
          </FullGrid>
        </ContainerGrid>
      </ContainerBlock>
      <ContainerGrid>
        <LeftGrid>
          <div className={marginTop}></div>
          <Heading>Summary details</Heading>
          <Listing sources={summaries} variant="dash" margin="0px" />
          <Divider size={1} color={theme.colors.grey[700]} margin="0 0 15px" />
          <ContainerBlock padding="0 15px" paddingTablet="0 15px">
            <Heading variant="desc" margin="0px">* Premium payment term is equal to the policy term</Heading>
          </ContainerBlock>
          <Divider size={1} color={theme.colors.grey[700]} variant="dashed" margin="0 0 30px" />
          <Heading
            variant="sub"
            fontWeight={600}
            color={theme.colors.grey[400]}
          >
            For any questions related to your policy or complaints, please contact us:
          </Heading>
          <ContactBox items={contactInformation} noDecorator={true} />
          <Text>Any claim matters, please visit <Link text='here' target="_blank" rel="noopener noreferrer" url='https://singlife.com/en/make-a-claim' /> where you can find out more on how to submit a claim.</Text>
        </LeftGrid>


      </ContainerGrid>
    </Container>
  );
};

export default ThankYou;
